import classNames from 'classnames'
import { MyInternalLink, MyLink, MyLinkClickHandler } from 'components/MyLink'
import { ReactNode } from 'react'
import Skeleton from 'react-loading-skeleton'

type ActionCardProps = {
  className?: string
  text: string
  href: string
  icon: ReactNode
  handleClick?: MyLinkClickHandler
  isLoading?: boolean
}
export const ActionCard = ({
  className,
  text,
  href,
  icon,
  handleClick,
  isLoading
}: ActionCardProps) => {
  const isExternal = Boolean(href && /^https?:\/\//.test(href))
  const classes = classNames('my-c-action-card', className)

  const Contents = ({ isLoading }: { isLoading?: boolean }) => (
    <div className="my-u-gap-x--6 ds-u-display--flex">
      {!isLoading && icon && <div>{icon}</div>}
      <div className="ds-text-heading--md ds-u-margin--0 my-u-flex-grow-1">
        {isLoading ? <Skeleton /> : text}
      </div>
    </div>
  )

  return (
    <>
      {isExternal && (
        <MyLink className={classes} href={href} onClick={handleClick}>
          <Contents isLoading={isLoading} />
        </MyLink>
      )}
      {!isExternal && (
        <MyInternalLink className={classes} to={href} onClick={handleClick}>
          <Contents isLoading={isLoading} />
        </MyInternalLink>
      )}
    </>
  )
}
